import React from "react";
import { Phone, Instagram, Mail, Clock } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const WhatsAppIcon = ({ size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24z"/></svg>
);

export default function Contact() {
  const { settings } = useSettings();
  const number = settings?.whatsapp || "2348094706281";
  const rows = [
    { icon: Phone, label: "Phone", value: settings?.phone, href: `tel:${settings?.phone || ""}` },
    { icon: WhatsAppIcon, label: "WhatsApp", value: settings?.phone, href: `https://wa.me/${number}` },
    { icon: Mail, label: "Email", value: settings?.email, href: `mailto:${settings?.email || ""}` },
    { icon: Instagram, label: "Instagram", value: "@sapore.eats", href: settings?.instagram || "#" },
  ];
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
      <p className="text-sapore-gold uppercase tracking-[0.3em] text-xs mb-3">Contact</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-bold text-sapore-purple">Get in touch</h1>
      <p className="text-sapore-inkSoft mt-3">We're a delivery-only kitchen — order online or reach us anytime.</p>

      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {rows.map((r) => (
          <a
            key={r.label}
            href={r.href}
            target={r.href.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={`contact-${r.label.toLowerCase()}`}
            className="flex items-center gap-4 bg-white rounded-2xl border border-sapore-border p-5 hover:-translate-y-0.5 hover:shadow-lg transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-sapore-purple text-sapore-gold flex items-center justify-center flex-shrink-0">
              <r.icon size={22} />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-sapore-muted">{r.label}</p>
              <p className="font-medium text-sapore-ink">{r.value}</p>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-6 bg-sapore-creamSurface rounded-2xl border border-sapore-border p-5 flex items-center gap-3">
        <Clock size={20} className="text-sapore-purple" />
        <div>
          <p className="text-xs uppercase tracking-widest text-sapore-muted">Business hours</p>
          <p className="font-medium text-sapore-ink">{settings?.business_hours || "By request"}</p>
        </div>
      </div>
      <p className="text-sm text-sapore-muted mt-6">Please note: we operate delivery only and do not publish a street address.</p>
    </div>
  );
}
